export const salaryTypes = {
    after: { id: 'after', title: 'after_discounts' },
    before: { id: 'before', title: 'before_discounts' }
}

export const percentTypes = {
    after_technic: { id: 'after_technic', title: 'after_technic_deduction' },
    before_technic: { id: 'before_technic', title: 'before_technic_deduction' }
}

export const salaryAccrualTypes = {
    payment: { id: 'payment', title: 'only_after_payment_received' },
    all: { id: 'all', title: 'all_visits' }
}

export const materialsWriteOffTypes = [
    { id: 'on_visit_save', title: 'on_visit_save' },
    { id: 'on_visit_close', title: 'on_visit_close' },
]

export const bonusUseTypes = {
    0: { id: 0, title: 'no' },
    1: { id: 1, title: 'yes' }
}

export const yesNoList = [
    { id: 'no', title: 'no' },
    { id: 'yes', title: 'yes' }
]

export const managerPercentTypes = {
    visit_add: { id: 'visit_add', title: 'to_the_one_who_made_record' },
    payment_received: { id: 'payment_received', title: 'to_the_one_who_accepted_payment' }
}

export const taskImportances = [
    { id: 'low', title: 'low' },
    { id: 'medium', title: 'medium' },
    { id: 'high', title: 'high' },
]

export const taskTypes = [
    { id: 'call', title: 'call_noun' },
    { id: 'task', title: 'task' },
]

export const recordStatuses = [
    { id: 1, title: 'not_confirmed' },
    { id: 2, title: 'confirmed' },
    { id: 3, title: 'came' },
    { id: 4, title: 'in_chair' },
    { id: 5, title: 'did_not_come' },
]

export const recordStatusesWithCancelled = [
    { id: 1, title: 'not_confirmed' },
    { id: 2, title: 'confirmed' },
    { id: 3, title: 'came' },
    { id: 4, title: 'in_chair' },
    { id: 5, title: 'did_not_come' },
    { id: 0, title: 'cancelled' },
]

export const taskStatuses = [
    { id: 'planned', title: 'planned' },
    { id: 'inprogress', title: 'inprogress' },
    { id: 'done', title: 'done' },
    { id: 'cancelled', title: 'cancelled' },
    { id: 'for_rework', title: 'to_rework' },
]

export const recordTypes = [
    { id: 'treatment', title: 'treatment' },
    { id: 'consultation', title: 'consultation' },
    { id: 'diagnostics', title: 'diagnostics' },
    { id: 'checkup', title: 'checkup' },
    { id: 'sanation', title: 'sanation' },
    { id: 'curation', title: 'curation' },
    { id: 'hygiene', title: 'hygiene' },
    { id: 'online_consultation', title: 'online_consultation' },
    { id: 'block', title: 'block' },
]

export const warehouseOperationTypes = [
    { id: "addition", title: "addition" },
    { id: "movement_from", title: "from_warehouse" },
    { id: "movement_to", title: "to_warehouse" },
    { id: "return", title: "return" },
    { id: "write_off", title: "write_off" },
    { id: "consumption", title: "consumption" },
    { id: "consumption_manual", title: "consumption_manual" },
    { id: "inventarization", title: "inventarization" }
]

export const warehouseOperationTypesToAdd = [
    { id: "addition", title: "addition" },
    { id: "movement_from", title: "from_warehouse" },
    { id: "return", title: "return" },
    { id: "write_off", title: "write_off" },
    { id: "inventarization", title: "inventarization" },
    { id: "consumption_manual", title: "consumption_manual" }
]

export const templateTypesToModelNames = {
    complaints_templates      : 'complaint_template',
    diagnosis                 : 'diagnosis_template',
    bite_templates            : 'bite_template',
    development_templates     : 'development_template',
    diseases_templates        : 'disease_template',
    inspection_templates      : 'inspection_template',
    medication_templates      : 'medication_template',
    objectively_templates     : 'objective_template',
    plansurvey_templates      : 'plansurvey_templates',
    recommendations_templates : 'recommendations_templates',
    research_templates        : 'research_template',
    subjectively_templates    : 'subjective_template'
}


export const roles = {
    2: 'superadministrator',
    3: 'administrator',
    4: 'doctor',
    5: 'patient',
    6: 'technic',
    7: 'assistant',
    8: 'curator',
}

export const rolesToChange = [
    { id: 3, title: 'administrator' },
    { id: 7, title: 'assistant' },
    { id: 8, title: 'curator' },
]

export const clinicAccountTypes = {
    0: { id: 0, title: 'test' },
    1: { id: 1, title: 'demo' },
    2: { id: 2, title: 'abonplata' },
    3: { id: 3, title: 'purchase' }
}

export const clinicLanguages = {
    'russian': { id: 'russian', title: 'russian' },
    'ukrainian': { id: 'ukrainian', title: 'ukrainian' },
    'uzbek': { id: 'uzbek', title: 'uzbek' },
    'english': { id: 'english', title: 'english' },
    'azerbaijani': { id: 'azerbaijani', title: 'azerbaijani' },
    'kazakh': { id: 'kazakh', title: 'kazakh' },
    'kyrgyz': { id: 'kyrgyz', title: 'kyrgyz' },
}


export const anketaCategories = {
    other: 'other',
    female: 'for_female_patients',
    diseases: 'diseases_passed_and_current',
    allergies: 'allergic_reactions',
    anamnesis: 'anamnesis'
}

export const templateGroups = [
    'teeth_plansurvey',
    'teeth_medication',
    'teeth_recommendations',
    'complaints',
    'inspection',
    'objectively',
    'subjectively',
    'diseases',
    'development',
    'bite',
    'research',
    'description'
]

export const templateGroupsWithTitles = [
    { id: 'teeth_plansurvey', title: 'teeth_plansurvey' },
    { id: 'teeth_medication', title: 'teeth_medication' },
    { id: 'teeth_recommendations', title: 'teeth_recommendations' },
    { id: 'complaints', title: 'complaints' },
    { id: 'inspection', title: 'inspection' },
    { id: 'objectively', title: 'objectively' },
    { id: 'subjectively', title: 'subjectively'},
    { id: 'diseases', title: 'life_anamnez' },
    { id: 'development', title: 'disease_anamnez' },
    { id: 'bite', title: 'bite' },
    { id: 'research', title: 'research' },
    { id: 'description', title: 'visit_description_doctor' }
]

export const fieldConfigMapping = {
    'complaints': 'complaints',
    'development': 'disease_anamnez',
    'diseases': 'life_anamnez',
    'inspection': 'inspection',
    'objectively': 'objectively',
    'subjectively': 'subjectively',
    'bite': 'bite',
    'research': 'results_of_xray_and_lab_research',
    'description_doctor': 'visit_description_doctor',
    'plansurvey': 'plansurvey',
    'medication': 'medication',
    'recommendations': 'recommendations',
    'epikriz': 'epikriz',
    'teeth_medication': 'medication',
    'teeth_plansurvey': 'plansurvey',
    'teeth_recommendations': 'recommendations'
}

export const planTemplateGroups = [
    'diagnoses',
    'services',
    'planned_treatment',
    'planned_result',
    'description',
    'date_to'
]

export const currencyForJson = [
    'usd',
    'rub',
    'kzt',
    // 'uah',
    'kgs'
]

export const currenciesForBilling = [
    { id: 'usd', title: 'usd' },
    { id: 'rub', title: 'rub' },
    { id: 'kzt', title: 'kzt' },
    { id: 'uah', title: 'uah' },
    { id: 'kgs', title: 'kgs' },
]

export const typesOfNotifications = [
    { id: 'before_visit', title: 'before_visit' },
    { id: 'after_visit', title: 'after_visit' },
    { id: 'visit_created', title: 'visit_created' },
    { id: 'visit_cancel', title: 'visit_cancel' },
    // { id: 'treatment_finished', title: 'treatment_finished' },
    { id: 'crm_application_created', title: 'crm_application_created' },
    { id: 'task_created', title: 'task_created' },
    { id: 'birthday', title: 'birth_day' },
    { id: 'patient_came', title: 'patient_came' },
    { id: 'patient_did_not_come', title: 'patient_did_not_come' },
    { id: 'treatment_plan_created', title: 'treatment_plan_created' },
    { id: 'plan_status_changed', title: 'plan_status_changed' },
    { id: 'complex_status_changed', title: 'complex_status_changed' },
    { id: 'since_last_visit', title: 'since_last_visit' },
    { id: 'visit_time_changed', title: 'visit_time_changed' },
    { id: 'after_service', title: 'after_service' },
    { id: 'bonus_accrued', title: 'bonus_accrued' },
    { id: 'before_visit_day_in_advance', title: 'before_visit_day_in_advance' },
    { id: 'after_visit_day_passed', title: 'after_visit_day_passed' },
    { id: 'laboratory_order_status_changed', title: 'laboratory_order_status_changed' },
]

export const timeTypes = [
    { id: 'minutes', title: 'minutes' },
    { id: 'hours', title: 'of_hours' },
    { id: 'days', title: 'of_days' },
]

export const notificationRoles = [
    { id: 2, title: 'superadministrator' },
    { id: 3, title: 'administrator' },
    { id: 4, title: 'doctor' },
    { id: 5, title: 'patient' },
    { id: 6, title: 'technic' },
    { id: 7, title: 'assistant' },
    { id: 8, title: 'curator' },
]


export const f057Types = [
    { id: 'therapist', title: 'therapist' },
    { id: 'orthodontist', title: 'orthodontist' },
    { id: 'orthopedist', title: 'orthopedist' },
]


export const teethLabels = {
    "В": "top_jaw",
    "Н": "bottom_jaw",
    "Р": "oral_cavity",
}


export const tariffsToChangeOurself = [
    { id: 2, title: 'Standard' },
    { id: 3, title: 'Premium' },
    { id: 13, title: 'Basic' },
]


export const leadStatuses = [
    { id: 'new', title: 'new', color: '#DD1515' },
    { id: 'not_reached', title: 'not_reached', color: 'rgba(7, 135, 201)' },
    { id: 'thinking', title: 'thinking', color: '#FEC943' },
    { id: 'recorded', title: 'recorded', color: '#5E9246' },
    { id: 'rejected', title: 'rejected', color: '#5D6D7C' },
    { id: 'stale', title: 'stale', color: '#5D6D7C' },
]

export const egiszStatuses = [
    { id: 'draft', title: 'draft', color: '#5D6D7C' },
    { id: 'requires_attention', title: 'requires_attention', color: '#DD1515' },
    { id: 'signed_by_doctor', title: 'signed_by_doctor', color: '#FEC943' },
    { id: 'signed_by_main_doctor', title: 'signed_by_main_doctor', color: '#5E9246' },
    { id: 'sent_to_egisz', title: 'sent_to_egisz', color: 'rgba(7, 135, 201)' },
]


export const planTreatmentStatuses = [
    { id: 'preliminary', title: 'preliminary', color: '#5D6D7C' },
    { id: 'confirmed', title: 'confirmed', color: '#FEC943' },
    { id: 'active', title: 'active', color: 'rgba(7, 135, 201)' },
    { id: 'treatment_complete', title: 'treatment_complete', color: '#5E9246' },
    { id: 'stopped', title: 'stopped', color: '#5D6D7C' },
    { id: 'rejected', title: 'rejected', color: '#DD1515' },
]

export const planTreatmentVisitStatuses = [
    { id: 'new', title: 'new', color: '#5D6D7C' },
    { id: 'in_process', title: 'in_process', color: '#FEC943' },
    { id: 'finished', title: 'finished', color: '#5E9246' },
]


export const leadSources = [
    { id: 'call', title: 'call_noun' },
    { id: 'whatsapp', title: 'whatsapp' },
    { id: 'telegram', title: 'telegram' },
    { id: 'crm-form', title: 'crm-form' },
    { id: 'online_booking', title: 'online_booking' },
    { id: 'va', title: 'va' },
    { id: 'Tilda', title: 'Tilda' },
    { id: 'other', title: 'other' },
]

export const months = [
    { id: '01', title: 'january' },
    { id: '02', title: 'february' },
    { id: '03', title: 'march' },
    { id: '04', title: 'april' },
    { id: '05', title: 'may' },
    { id: '06', title: 'june' },
    { id: '07', title: 'july' },
    { id: '08', title: 'august' },
    { id: '09', title: 'september' },
    { id: '10', title: 'october' },
    { id: '11', title: 'november' },
    { id: '12', title: 'december' },
]

export const cashOperations = [
    { id: 'injection', title: 'filling' },
    { id: 'withdrawal', title: 'withdrawal' },
]

export const f057Categories = [
    { type: 'title', title: 'Терапевт' },
    { type: 'title', title: 'Наложение пломб по поводу' },
    { type: 'category', title: 'Неосложнённый кариес' },
    { type: 'item', title: 'Поверхностный', id: 'cavity_low' },
    { type: 'item', title: 'Средний', id: 'cavity_medium' },
    { type: 'item', title: 'Глубокий', id: 'cavity_high' },
    { type: 'category', title: 'Осложненный кариес' },
    { type: 'item', title: 'Пульпит', id: 'pulpit' },
    { type: 'item', title: 'Периоднотит', id: 'periodontit' },
    { type: 'item', title: 'Некариозионные поражения зубов', id: 'nekarioz' },
    { type: 'category', title: 'Профилактическая работа' },
    { type: 'item', title: 'Осмотрено в плановом порядке', id: 'plan_reviewed' },
    { type: 'item', title: 'Нуждалось в санации из числа осмотренных', id: 'need_sanation' },
    { type: 'item', title: 'Вылечено из числа нуждающихся в санации', id: 'need_sanation_cured' },
    { type: 'category', title: 'Гингивит' },
    { type: 'item', title: 'Катаральный', id: 'cataral' },
    { type: 'item', title: 'Гипертрофический', id: 'hypertroph' },
    { type: 'item', title: 'Язвенный', id: 'ulcerative' },
    { type: 'title', title: 'Закончен курс лечения по поводу' },
    { type: 'category', title: 'Парадонтит' },
    { type: 'item', title: 'Легкая степень', id: 'paradontit_low' },
    { type: 'item', title: 'Средняя степень', id: 'paradontit_medium' },
    { type: 'item', title: 'Тяжелая степень', id: 'paradontit_high' },
    { type: 'category', title: 'Парадонтоз' },
    { type: 'item', title: 'Парадонтоз', id: 'paradontoz' },
    { type: 'item', title: 'Заболевания слизистой', id: 'slizist' },
    { type: 'title', title: 'Хирургические вмешательства' },
    { type: 'category', title: 'Удалено зубов' },
    { type: 'item', title: 'Всего', id: 'removed_total' },
    { type: 'item', title: 'По поводу заболеваний пародонта', id: 'removed_paradont' },
    { type: 'item', title: 'Экстренные операции', id: 'extra_oper' },
    { type: 'item', title: 'Имплантация (Число имплантов)', id: 'implant' },
    { type: 'item', title: 'Плановые операции в т.ч. операции нтр', id: 'planned_oper' },
    { type: 'item', title: 'Санировано', id: 'sanated' },

    { type: 'title', title: 'Ортодонт' },
    { type: 'category', title: 'Внутриротовые несъемные аппараты' },
    { type: 'item', title: 'Механического действия', id: 'non_removing_mechanical' },
    { type: 'item', title: 'Функционального действия', id: 'non_removing_functional' },
    { type: 'category', title: 'Внутриротовые съемные аппараты' },
    { type: 'item', title: 'Механического действия', id: 'removing_mechanical' },
    { type: 'item', title: 'Функционального действия', id: 'removing_functional' },
    { type: 'category', title: 'Аппараты сочетанного действия' },
    { type: 'item', title: 'Аппараты сочетанного действия', id: 'mixed_apparatus' },
    { type: 'category', title: 'Протезы' },
    { type: 'item', title: 'Несъемные', id: 'prothez_non_removing' },
    { type: 'item', title: 'Съемные', id: 'prothez_removing' },
    { type: 'item', title: 'В том числе ортопедические', id: 'prothez_orthopedic' },
    { type: 'category', title: 'Число лиц, которым закончено ортодонтическое лечение' },
    { type: 'item', title: 'с аномалиями отдельных зубов', id: 'orthodont_anomaly_teeth' },
    { type: 'item', title: 'с аномалиями зубных рядов', id: 'orthodont_anomaly_rows' },
    { type: 'item', title: 'с сагиттальными аномалиями прикуса', id: 'orthodont_anomaly_prikus' },
    { type: 'item', title: 'с трансверзальными аномалиями прикуса', id: 'orthodont_anomaly_tranverse' },
    { type: 'item', title: 'с вертикальными аномалиями прикуса', id: 'orthodont_anomaly_vertical' },

    { type: 'title', title: 'Ортопед' },
    { type: 'category', title: 'Искусственные коронки (одиночные на зубах)' },
    { type: 'item', title: 'металлические', id: 'orthoped_metal' },
    { type: 'item', title: 'штампованные', id: 'orthoped_stamped' },
    { type: 'item', title: 'литые', id: 'orthoped_filled' },
    { type: 'item', title: 'Пластмассовые коронки и зубы (прямые)', id: 'orthoped_plastic_direct' },
    { type: 'item', title: 'Пластмассовые коронки и зубы (непрямые)', id: 'orthoped_plastic_indirect' },
    { type: 'item', title: 'виниры', id: 'orthoped_vinirs' },
    { type: 'item', title: 'керамические м/к', id: 'orthoped_ceramics_mk' },
    { type: 'item', title: 'керамические цирконивые', id: 'orthoped_ceramics_circonium' },
    { type: 'item', title: 'керамические цельно-керамические', id: 'orthoped_ceramics_whole' },
    { type: 'category', title: 'Коронки на имплантах одиночные' },
    { type: 'item', title: 'металлокерамические', id: 'orthoped_cor_metal' },
    { type: 'item', title: 'коронок циркон', id: 'orthoped_cor_cirkonium' },
    { type: 'item', title: 'цельно керамические', id: 'orthoped_cor_whole' },
    { type: 'category', title: 'Мостовидные протезы' },
    { type: 'item', title: 'литых зубов метал', id: 'orthoped_filled_teeth_metal' },
    { type: 'item', title: 'литых зубов металлокерамика', id: 'orthoped_filled_teeth_metalceramics' },
    { type: 'item', title: 'литых зубов цельно-керамические', id: 'orthoped_filled_teeth_whole' },
    { type: 'item', title: 'литых зубов', id: 'orthoped_filled_teeth' },
    { type: 'item', title: 'зубов м/к', id: 'orthoped_most_mk' },
    { type: 'item', title: 'цельно-керамические', id: 'orthoped_most_ceramics' },
    { type: 'category', title: 'Штифтовые зубы' },
    { type: 'item', title: 'Штифтовые зубы', id: 'orthoped_stift' },
    { type: 'category', title: 'Съемные протезы' },
    { type: 'item', title: 'Частичные пластиночные', id: 'orthoped_prothes_plastin' },
    { type: 'item', title: 'Полные пластмасса', id: 'orthoped_prothes_plastic' },
    { type: 'item', title: 'Частичные бюгельные на аттачменте', id: 'orthoped_prothes_bugel_attach' },
    { type: 'item', title: 'Частичные бюгельные на кламмерах', id: 'orthoped_prothes_bugel_clammer' },
    { type: 'item', title: 'Полные съемные пластиночные протезы', id: 'orthoped_prothes_full_removing' },
    { type: 'category', title: 'Лица, получившие протез' },
    { type: 'item', title: 'Всего', id: 'orthoped_prothes_total_people' },
    { type: 'item', title: 'В том числе бесплатно', id: 'orthoped_prothes_free_people' },
]

export const superUserRoles = [
    { id: "superadmin", title: "superadmin" },
    { id: "supermanager", title: "supermanager" },
    { id: "manager", title: "manager2" },
    { id: "tech_specialist", title: "tech_specialist" },
    { id: "partner", title: "partner" },
    { id: "account_manager", title: "account_manager" },
]

export const permanentPatientOptions = [
    { id: "more_than_one_visit", title: "more_than_one_visit" },
    { id: "more_than_one_day", title: "more_than_one_day" },
    { id: "one_visit_that_came", title: "one_visit_that_came" },
]

export const jetAPIStatuses = [
    { "code": 0, "status": "Ошибка оператора", "type": "финальный" },
    { "code": 1, "status": "Передано оператору", "type": "промежуточный" },
    { "code": 2, "status": "Доставлено", "type": "финальный" },
    { "code": 3, "status": "Просрочено", "type": "финальный" },
    { "code": 4, "status": "Удалено", "type": "финальный" },
    { "code": 5, "status": "Невозможно доставить", "type": "финальный" },
    { "code": 6, "status": "Принято", "type": "промежуточный" },
    { "code": 7, "status": "Неизвестная ошибка", "type": "финальный" },
    { "code": 8, "status": "Отклонено", "type": "финальный" },
    { "code": 9, "status": "Ошибка сервера", "type": "финальный" },
    { "code": 10, "status": "Необрабатываемая ошибка", "type": "финальный" },
    { "code": 11, "status": "Неверный номер", "type": "финальный" },
    { "code": 12, "status": "Запрещено", "type": "финальный" },
    { "code": 13, "status": "Недостаточно средств", "type": "финальный" },
    { "code": 14, "status": "Ожидает отправки", "type": "промежуточный" },
    { "code": 15, "status": "В обработке", "type": "промежуточный" },
    { "code": 16, "status": "Прочитано", "type": "финальный" },
    { "code": 17, "status": "Превышен лимит запросов", "type": "финальный" },
    { "code": 21, "status": "На модерации", "type": "промежуточный" },
    { "code": 22, "status": "Модерация отклонена", "type": "финальный" },
    { "code": 25, "status": "Ограничения отправки", "type": "финальный" },
    { "code": 26, "status": "Ограничения длины сообщений", "type": "финальный" },
    { "code": 27, "status": "Ограничения отправки в Казахстан", "type": "промежуточный" },
    { "code": 28, "status": "Ограничение по оператору", "type": "финальный" },
    { "code": 31, "status": "Ошибка при создании", "type": "финальный" },
    { "code": 32, "status": "WhatsApp не оплачен", "type": "финальный" },
    { "code": 33, "status": "Неверные параметры отправки", "type": "финальный" },
    { "code": 34, "status": "Ограничения отправки", "type": "финальный" },
    { "code": 35, "status": "Превышен лимит запросов на доставку", "type": "финальный" },
    { "code": 44, "status": "WhatsApp незарегистрированный номер", "type": "финальный" },
    { "code": 45, "status": "Сессия WhatsApp не запущена", "type": "финальный" },
    { "code": 50, "status": "Telegram не авторизован", "type": "финальный" },
    { "code": 51, "status": "Отправитель не является участником группового чата", "type": "финальный" },
    { "code": 555, "status": "В черном списке", "type": "финальный" },
];

export const patientCommentTypes = [
    { id: 'all', title: 'all' },
    { id: 'manual', title: 'comments' },
    { id: 'record', title: 'visits' },
    { id: 'notification', title: 'notifications' },
    { id: 'payment', title: 'payments' },
    { id: 'advance', title: 'deposit' },
    { id: 'treatment_plan', title: 'plan_treatments' },
    { id: 'task', title: 'tasks' },
    { id: 'lead', title: 'leads' },
    { id: 'bonus', title: 'bonuses' },
    { id: 'call', title: 'calls' },
    { id: 'visit_timing', title: 'visit_time' },
    { id: 'patient', title: 'patient' },
];

export const countries = {
    UKRAINE: 1,
    POLAND: 2,
    RUSSIA: 3,
    UNKNOWN: 4,
    KAZAKHSTAN: 5,
    BELARUS: 6,
    AZERBAIJAN: 7,
    ARMENIA: 8,
    MOLDOVA: 9,
    KYRGYZSTAN: 10,
    TAJIKISTAN: 11,
    UZBEKISTAN: 12
}

export const outgoingCallTypes = [
    { id: 'standard', title: 'standard' },
    { id: 'binotel', title: 'binotel' },
    { id: 'sipuni', title: 'sipuni' },
    { id: 'uis', title: 'uis' },
    { id: 'pbx', title: 'pbx' },
]

export const countryPaySystems = [
    { id: 'ioka', title: 'ioka' },
    { id: 'robokassa', title: 'robokassa' },
    { id: 'tinkoff', title: 'tinkoff' },
    { id: 'obank', title: 'obank' },
]

export const notificationStatuses = [
    { id: 'sent', title: 'sent' },
    { id: 'error', title: 'error' },
    { id: 'cancelled', title: 'cancelled' },
    { id: 'waiting', title: 'waiting' },
]

export const notificationTypes = [
    { id: 'manual', title: 'manual' },
    { id: 'notification_setting', title: 'notification_setting' },
    { id: 'mailing', title: 'mailing' },
]

export const aqsiTaxModes = [
    { id: 1, title: "20%" },
    { id: 2, title: "10%" },
    { id: 3, title: "20/120" },
    { id: 4, title: "10/110" },
    { id: 5, title: "0%" },
    { id: 6, title: "not_subject_to_vat" },
]

export const kkmTaxModes = [
    { id: 20, title: "20%" },
    { id: 10, title: "10%" },
    { id: 120, title: "20/120" },
    { id: 122, title: "22/122" },
    { id: 110, title: "10/110" },
    { id: 105, title: "5/105" },
    { id: 107, title: "7/107" },
    { id: 0, title: "0%" },
    { id: 5, title: "5%" },
    { id: 7, title: "7%" },
    { id: 10, title: "10%" },
    { id: 22, title: "22%" },
    { id: -1, title: "not_subject_to_vat" },
]

export const kkmAdvanceTypes = [
    { id: 'advance', title: 'advance_noun' },
    { id: 'prepayment', title: 'partial_prepayment' },
    { id: 'credit', title: 'credit' },
]

export const kkmCashierTypes = [
    { id: 'auto', title: 'who_accepts_payment' },
    { id: 'fixed', title: 'fixed' },
]

export const leadCallResponsibleOptions = [
    { id: 'admins', title: 'all_administrators' },
    { id: 'callee', title: 'callee' },
    { id: 'user_id', title: 'manually_selected_user' },
    { id: 'nobody', title: 'nobody' },
]

export const leadResponsibleOptions = [
    { id: 'admins', title: 'all_administrators' },
    { id: 'user_id', title: 'manually_selected_user' },
    { id: 'nobody', title: 'nobody' },
]

export const planTreatmentTypes = [
    { id: 'recommended', title: 'recommended' },
    { id: 'alternative', title: 'alternative' },
    { id: 'additional', title: 'additional' },
]

export const bonusOperationTypes = [
    { id: 'manual_adjustment', title: 'manual_adjustments' },
    { id: 'accrual', title: 'accrual' },
    { id: 'payment', title: 'payment' },
]

export const funnelPatientStatuses = [
    { id: 'new', title: 'new', color: '#5D6D7C' },
    { id: 'curator_assigned', title: 'curator_assigned', color: '#FEC943' },
    { id: 'treatment_plan_created', title: 'treatment_plan_created', color: '#0787C9' },
    { id: 'treatment_plan_signed', title: 'treatment_plan_signed', color: '#5E9246' },
    { id: 'treatment_started', title: 'treatment_started', color: '#5D6D7C' },
    { id: 'treatment_finished', title: 'treatment_finished', color: '#5D6D7C' },
    { id: 'treatment_refused', title: 'treatment_refused', color: '#DD1515' },
]

export const visitPayTypes = [
    { id: 'payable', title: 'payable' },
    { id: 'insurance', title: 'insurance' },
]

export const billingPaymentForTypes = [
    { id: 'tariff', title: 'tariff' },
    { id: 'additional_space', title: 'additional_space' },
    { id: 'additional_doctors', title: 'additional_doctors' },
    { id: 'additional_jet_api', title: 'additional_jet_api' },
    { id: 'additional_green_api', title: 'additional_green_api' },
    { id: 'additional_functionality', title: 'Доп функционал' },
    { id: 'additional_services', title: 'Доп услуги' },
]

export const onlineContractLicenseTypes = [
    { id: 0, title: 'Trial: Бесплатный (для ознакомления)' },
    { id: 1, title: 'SmallFolder: Малый бизнес' },
    { id: 2, title: 'MiddleFolder: Средний бизнес' },
    { id: 3, title: 'BigFolder: Крупный бизнес' },
    { id: 4, title: 'AgileFolder: Гибкий' },
    { id: 5, title: 'Startup: Стартап' },
    { id: 6, title: 'StartupPlus: Стартап+' },
    { id: 7, title: 'SmallFolderPlus: Малый бизнес+' },
    { id: 8, title: 'SmallFolderPlusPlus: Малый бизнес++' },
    { id: 9, title: 'MiddleFolderPlus: Средний бизнес+' },
    { id: 10, title: 'MiddleFolderPlusPlus: Средний бизнес++' },
    { id: 11, title: 'DocumentTemplate: Разработка шаблона документа' },
]

export const onlineContractLicenseTypesForPayment = [
    { id: 0, title: 'Бесплатный (для ознакомления)' },
    { id: 5, title: 'Startup (25 документов)' },
    { id: 6, title: 'Startup+ (50 документов)' },
    { id: 1, title: 'SmallFolder (100 документов)' },
    { id: 7, title: 'SmallFolder+ (200 документов)' },
    { id: 8, title: 'SmallFolder++ (500 документов)' },
]

export const onlineContractSignTypes = [
    { id: 0, title: 'DigitalSign: ЭЦП' },
    { id: 1, title: 'SmsCode: SMS код' },
    { id: 2, title: 'Faksimile: Факсимиле' },
    { id: 3, title: 'EgovQrSign: QR подписание E-gov Mobile' },
    { id: 4, title: 'AituSign: Облачное подписание' },
    { id: 5, title: 'BiometricSmsCode: Биометрия + SMS код' },
    { id: 6, title: 'WhatsAppCode: WhatsApp код' },
    { id: 7, title: 'EmailCode: Email код' },
]

export const onlineContractLegalTypes = [
    { id: 0, title: 'Juridical: Юридическое лицо' },
    { id: 1, title: 'Physical: Физическое лицо' },
    { id: 2, title: 'Ip: Индивидуальный предприниматель' },
    { id: 3, title: 'Employee: Сотрудник' },
    { id: 4, title: 'Unknown: Не указан' },
]

export const onlineContractSendTypes = [
    { id: 0, title: 'SendByEmail: Отправка по Email' },
    { id: 1, title: 'SendBySms: Отправка по SMS' },
    { id: 2, title: 'SendByWhatsApp: Отправка по WhatsApp' },
]

export const onlineContractPaymentTypes = [
    { id: 0, title: 'ByPaymentInvoice: Оплата банковским переводом (Счет на оплату)' },
    { id: 1, title: 'ByBankCard: Оплата банковской картой' },
    { id: 3, title: 'ByKaspiQR: Оплата через Kaspi QR' },
]

export const onlineContractContractStatuses = [
    { id: 0, title: 'Draft: Черновик' },
    { id: 1, title: 'EditEnded: Редактирование завершено' },
    { id: 2, title: 'OnDiscussion: На обсуждении' },
    { id: 3, title: 'AtSigning: На подписании' },
    { id: 4, title: 'Signed: Подписан' },
    { id: 5, title: 'InArchive: В архиве' },
    { id: 6, title: 'AtContragentSigning: На подписании у контрагента' },
    { id: 7, title: 'WaitingRequisites: В ожидании реквизитов' },
    { id: 8, title: 'WaitingValidation: Ожидает проверки' },
    { id: 9, title: 'WaitingFiles: В ожидании файлов' },
    { id: 10, title: 'WaitingFamiliarization: В ожидании ознакомления' },
    { id: 11, title: 'Familiarized: Ознакомление завершено' },
    { id: 12, title: 'WaitingApproval: В ожидании согласования' },
    { id: 13, title: 'NotApproved: Не согласован' },
    { id: 14, title: 'Approved: Согласован' },
    { id: 15, title: 'WaitingExecution: В ожидании исполнения' },
    { id: 16, title: 'Executed: Исполнен' },
    { id: 17, title: 'OnView: На просмотр' },
    { id: 18, title: 'Nullified: Аннулирован' },
    { id: 19, title: 'Revoked: Отозван' }
]

export const labTypes = [
    { id: 'laboratory', title: 'laboratory' },
    { id: 'technic', title: 'technic' },
]

export const serviceLaboratoryTypes = [
    { id: 'optional', title: 'can_have_dental_work' },
    { id: 'required', title: 'must_have_dental_work' },
]

export const laboratoryOrderStatuses = [
    { id: 'new', title: 'new' },
    { id: 'in_lab', title: 'in_lab' },
    { id: 'in_clinic', title: 'in_clinic' },
    { id: 'finished', title: 'finished' },
    { id: 'cancelled', title: 'cancelled' },
]

export const recordOpenedClosedStatuses = [
    { id: 'new', title: 'new' },
    { id: 'opened', title: 'opened' },
    { id: 'closed', title: 'closed' },
]

export const aiStudyTypes = [
    { id: 'panorama', title: 'panorama' },
    { id: 'cbct', title: 'CBCT' },
    { id: 'fmx', title: 'FMX' },
    { id: 'stl', title: 'STL' },
]

export const aiStudyStatuses = [
    { id: 'new', title: 'new' },
    { id: 'initiated', title: 'initiated' },
    { id: 'uploaded', title: 'uploaded' },
]

export const calendarCardShowFirstOptions = [
    { id: 'name', title: 'fio' },
    { id: 'date', title: 'time' },
]

export const onlineBookingPaths = [
    { id: 'doctor-services', title: 'doctor-services' },
    { id: 'services-doctor', title: 'services-doctor' },
]

export const notificationVisitTypes = [
    { id: 'all', title: 'all' },
    { id: 'primary', title: 'primary' },
    { id: 'repeated', title: 'repeated' },
]

export const marketAppIntegrations = [
    { id: 'greenAPI', right: 'green_api', panelId: 'green-c', title: 'Green API' },
    { id: 'greenAPITelegram', right: 'green_api_telegram', panelId: 'green-c-telegram', title: 'Green API Telegram' },
    { id: 'jetAPI', right: 'jet_api', panelId: 'jet-c', title: 'Jet API' },
    { id: 'wazzup', right: '', panelId: 'wazzup-c', title: 'Wazzup' },
    { id: 'max', right: 'max', panelId: 'green-c-max', title: 'Max' },
    { id: 'telegram_bot', right: 'telegram_bot', panelId: '', title: 'Telegram Bot' },
    { id: 'webkassa', right: 'webkassa', panelId: 'collapse-webkassa', title: 'Webkassa' },
    { id: 'aqsi', right: 'aqsi', panelId: 'collapse-aqsi', title: 'AQSI' },
    { id: 'kkm', right: 'kkm', panelId: 'collapse-kkm', title: 'KKM' },
    { id: 'newCas', right: 'newcas', panelId: 'newcas-c', title: 'NewCas' },
    { id: 'egisz', right: 'egisz_view', panelId: '', title: 'EGISZ' },
    { id: 'smsc', right: 'sms_send', panelId: 'sms-c', title: 'SMSC' },
    { id: 'smsFly', right: 'sms_send', panelId: 'sms-c', title: 'SMS Fly' },
    { id: 'msmSms', right: 'sms_send', panelId: 'sms-c', title: 'MSM SMS' },
    { id: 'prostor', right: 'sms_send', panelId: 'sms-c', title: 'Prostor' },
    { id: 'kazInfoTech', right: 'sms_send', panelId: 'sms-c', title: 'KazInfoTech' },
    { id: 'eskiz', right: 'sms_send', panelId: 'sms-c', title: 'Eskiz' },
    { id: 'onlineContract', right: 'online_contract', panelId: 'online-contract-kz', title: 'Online contract' },
    { id: 'trustMe', right: '', panelId: 'trustme-c', title: 'TrustMe' },
    { id: 'fdoc', right: 'fdoc', panelId: 'fdoc-integration', title: 'FDoc' },
    { id: 'esia', right: 'esia_sign', panelId: 'esia-c', title: 'ЕСИА (Госуслуги)' },
    { id: 'diagnocat', right: 'diagnocat', panelId: 'diagnocat-c', title: 'DiagnoCat' },
    { id: 'binotel', right: 'crm', panelId: 'binotel-c', title: 'Binotel' },
    { id: 'sipuni', right: 'crm', panelId: 'sipuni-c', title: 'Sipuni' },
    { id: 'uis', right: 'crm', panelId: 'uis-c', title: 'UIS' },
    { id: 'pbx', right: 'crm', panelId: 'pbx-c', title: 'PBX' },
    { id: 'voip', right: 'voip', panelId: 'voip-c', title: 'VOIP' },
    { id: 'prodoctorov', right: 'prodoctorov', panelId: 'prodoctorov-c', title: 'Prodoctorov' },
    { id: 'tilda', right: 'crm', panelId: 'tilda-c', title: 'Tilda' },
    { id: 'online_booking', right: 'online_booking', panelId: '', title: 'Онлайн-запись' },
]

export const canbanModeTypes = {
    auto: { id: 'auto', title: 'auto' },
    manual: { id: 'manual', title: 'manual' }
}

export const canbanAutoSteps = [
    { id: 'new', title: 'new', color: '#5D6D7C' },
    { id: 'treatment_plan_created', title: 'treatment_plan_created_2', color: '#0b243c' },
    { id: 'treatment_plan_signed', title: 'treatment_plan_signed', color: '#FEC943' },
    { id: 'treatment_started', title: 'undergoing_treatment', color: '#0787C9' },
    { id: 'patient_stopped_treatment', title: 'patient_stopped_treatment', color: '#000000' },
    { id: 'treatment_plan_finished', title: 'treatment_plan_finished', color: '#5E9246' },
    { id: 'patient_lost', title: 'patient_lost', color: '#DD1515' }
]

export const signedStatuses = [
    { id: 'signed', title: 'signed' },
    { id: 'not_signed', title: 'not_signed' },
]

export const responsibleTypes = [
    { id: 'curator', title: 'patient_curator' },
    { id: 'admin', title: 'created_visit_administrator' },
    { id: 'visit_doctor', title: 'visit_doctor' },
    { id: 'patient_doctor', title: 'treating_doctor' },
]

export const additionalClinicOptionsFilter = [
    { id: 'warehouse_connected', title: 'Модуль склад' },
    { id: 'crm_connected', title: 'Модуль CRM' },
    { id: 'branches_connected', title: 'Модуль филиалы' },
    { id: 'jetapi_connected', title: 'Модуль JET API' },
    { id: 'greenapi_connected', title: 'Модуль Green API' },
    { id: 'max_connected', title: 'Модуль Max' },
    { id: 'assistants_connected', title: 'Модуль ассистенты' },
    { id: 'bonus_connected', title: 'Модуль бонусов' },
    { id: 'telegram_bot_connected', title: 'Telegram Bot' },
    { id: 'greenapi_telegram_connected', title: 'Модуль Green API Telegram' },
    { id: 'max_bot_connected', title: 'Max Bot' },
    { id: 'has_additional_doctors', title: 'Есть дополнительные врачи' },
]

export const clinicBusinessTypes = [
    { id: 'dental', title: 'Стоматология' },
    { id: 'medical', title: 'Общая медицина' },
]

export const patientStatusTypes = [
    { id: 'permanent', title: 'permanent' },
    { id: 'primary', title: 'primary' },
]

export const apiAccessTypes = [
    { id: 'standard', title: 'standard' },
    { id: 'professional', title: 'professional' },
]

export const legalDocumentTypes = [
    { id: 'offer_contract', title: 'legal_document_type_offer_contract' },
    { id: 'integrations_agreement', title: 'legal_document_type_integrations_agreement' },
    { id: 'usage_agreement', title: 'legal_document_type_usage_agreement' },
]

export const labServicesDeductionOptions = [
    { id: 'only_finished', title: 'after_finished_fixed' },
    { id: 'immediate', title: 'immediately' },
]

export const visitFieldsToDuplicate = [
    { id: 'complaints', title: 'complaints' },
    { id: 'development', title: 'disease_anamnez' },
    { id: 'diseases', title: 'life_anamnez' },
    { id: 'inspection', title: 'inspection' },
    { id: 'objectively', title: 'objectively' },
    { id: 'subjectively', title: 'subjectively' },
    { id: 'bite', title: 'bite' },
    { id: 'research', title: 'research' },
    { id: 'description', title: 'visit_comment' },
    { id: 'description_doctor', title: 'visit_description_doctor' },
    { id: 'epikriz', title: 'epikriz' },
]

export const adultTeeth = [
    '18', '17', '16', '15', '14', '13', '12', '11',
    '21', '22', '23', '24', '25', '26', '27', '28',
    '48', '47', '46', '45', '44', '43', '42', '41',
    '31', '32', '33', '34', '35', '36', '37', '38'
]

export const babyTeeth = [
    '55', '54', '53', '52', '51',
    '61', '62', '63', '64', '65',
    '85', '84', '83', '82', '81',
    '71', '72', '73', '74', '75',
]

export const planTreatmentGenericFields = [
    'message',
    'plan_type',
    'complaints',
    'planned_date',
    'discount_value',
    'discount_type',
    'doctor_id',
    'manual_status',
    'status',
    'insurance_polis_id'
]

export const planTreatmentAutosavedFields = [
    'message',
    'plan_type',
    'complaints',
    'discount_value',
    'discount_type',
    'doctor_id',
    'manual_status',
    'insurance_polis_id'
]

export const logSources = [
    { id: 'web', title: 'web' },
    { id: 'api', title: 'api' },
    { id: 'integration', title: 'integration' },
    { id: 'system', title: 'system' },
]

export const diagnosisDictionaries = [
    { id: 'dentist_plus', title: 'dentist_plus' },
    { id: 'egisz', title: 'egisz' },
]
